
import "../styles/HomePageStyle.css"

function HomePage() {
  return (
<>
    <div className="hero">
      <div className="hero-content">
        <h2>Hello, I am Tanner Culley, an IT Business Analyst at Carnival Corporation.</h2>
         <p className="hero-intro">
       I began my career in marketing, where I discovered a passion for software and technology. This interest inspired me to learn web development and transition into technology-focused roles.
    </p>
    <p className="hero-intro">Today, I work at Carnival Corporation in IT compliance, helping ensure the security of our maritime applications. My role also spans system administration, data analysis, and visualization, while giving me the opportunity to collaborate closely with international colleagues in Italy and Germany.</p>
      </div>
    </div>
    </>

    
  );
  }
export default HomePage